// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1483":"b8f04e9d","3558":"b8f04e9d","4211":"b8f04e9d","8595":"b8f04e9d"}[chunkId] + ".chunk.css";
};